import React from "react";
import { Link } from "react-router-dom";
import { Mail, Instagram, BookText } from "lucide-react";

/**
 * Site-wide footer with contact + social links — visible on every page.
 * Deliberately restrained to match the meditative brand.
 */
export default function Footer() {
  // Shared tap-target class — 44px min touch target on mobile per WCAG 2.5.5,
  // shrinks to comfortable inline padding on ≥sm to preserve the editorial feel.
  const linkCls =
    "inline-flex items-center justify-center gap-2 min-h-[44px] px-3 py-2 sm:min-h-0 sm:px-1 sm:py-1 font-sans text-xs uppercase tracking-[0.24em] text-bone-400 hover:text-terracotta transition-colors";
  return (
    <footer className="border-t border-obsidian-600 mt-16 py-6 sm:py-8 px-4 sm:px-6 md:px-12">
      <div className="max-w-6xl mx-auto flex flex-col md:flex-row items-center justify-between gap-4">
        <p className="font-sans text-[0.65rem] uppercase tracking-[0.24em] text-bone-500 text-center">
          Umbra · a voice-first shadow journal
        </p>
        <div className="flex items-center gap-1 sm:gap-6 flex-wrap justify-center">
          <Link
            to="/blog"
            data-testid="footer-blog-link"
            className={linkCls}
          >
            <BookText className="h-3 w-3" />
            <span>Journal</span>
          </Link>
          <Link
            to="/about"
            data-testid="footer-about-link"
            className={linkCls}
          >
            About
          </Link>
          <Link
            to="/faq"
            data-testid="footer-faq-link"
            className={linkCls}
          >
            FAQ
          </Link>
          <Link to="/vs/the-shadow-work-journal" data-testid="footer-vs-book-link" className={linkCls}>
            Vs the workbook
          </Link>
          <Link to="/vs/symponia" data-testid="footer-vs-symponia-link" className={linkCls}>
            Vs Symponia
          </Link>
          <Link to="/vs/inneros" data-testid="footer-vs-inneros-link" className={linkCls}>
            Vs InnerOS
          </Link>
          <Link
            to="/terms"
            data-testid="footer-terms-link"
            className={linkCls}
          >
            Terms
          </Link>
          <Link
            to="/privacy"
            data-testid="footer-privacy-link"
            className={linkCls}
          >
            Privacy
          </Link>
          <a
            href="https://www.instagram.com/shadowspeakjournal/"
            target="_blank"
            rel="noopener noreferrer"
            data-testid="footer-instagram-link"
            aria-label="Follow Umbra on Instagram"
            className={linkCls}
          >
            <Instagram className="h-3 w-3" />
            <span className="hidden sm:inline">@shadowspeakjournal</span>
          </a>
          <a
            href="mailto:hello@shadowspeakjournal.com"
            data-testid="footer-contact-link"
            className={linkCls}
          >
            <Mail className="h-3 w-3" />
            Contact
          </a>
        </div>
      </div>
    </footer>
  );
}
